import { render, staticRenderFns } from "./NumberOptions.vue?vue&type=template&id=6c881dbf&scoped=true&"
import script from "./NumberOptions.vue?vue&type=script&lang=js&"
export * from "./NumberOptions.vue?vue&type=script&lang=js&"
import style0 from "./NumberOptions.vue?vue&type=style&index=0&id=6c881dbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c881dbf",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
